<div class="p-grid header-template">
  <div class="disp-icon">
    <fa-icon icon="home"></fa-icon>
  </div>
  <div class="p-col header-info">
    <div class="p-grid p-justify-between">
      <div class="p-col-9 property-search-address">
        <span class="property-search-address-main">
          {{property.Address.Address1}}
        </span>
        {{property.Address.City}}, {{property.Address.State}} {{property.Address.PostalCode}}
        <span class="fav-icon-left">
          <i #favIconEl
            [attr.data-fav-loan-icon-id]="'fav-loan-' + property.PropertyId" 
            [attr.data-fav-loan-flag]="property.IsFavorite"
            [ngClass]="getFavIconClass(property.IsFavorite)" 
            (click)="updateFavorite(favIconEl, property.PropertyId)">
          </i>
        </span>
      </div>
      <div class="p-col-3 strategy-corner strategy-corner-prefcl">{{property.DispositionStrategyGroup}}</div>
    </div>
   
    <div class="p-grid">
      <div class="p-col-2">
        <span class="property-search-label">Loan Number</span><br/>
        <span *ngIf="!showPropertyIdLink; else propertyIdLink" class="property-search-values">
          {{property.LoanNumber}}
        </span>
        <ng-template #propertyIdLink>
          <span class="property-search-values">
            <a href="{{routes?.viewTasks}}&property_id={{property.PropertyId}}">{{property.LoanNumber}}</a>
          </span>
        </ng-template>
        <a *ngIf="showOpenNewWindowIcon" href="{{routes?.viewTasks}}&property_id={{property.PropertyId}}" target="_blank">
          &nbsp;
          <i class="pi pi-external-link"></i>
        </a>
      </div>
      <div class="p-col-2"><span class="property-search-label">Servicer Loan Number</span><br/><span class="property-search-values">{{property.ServicerloanNumber}}</span></div>
      <div class="p-col-2"><span class="property-search-label">EQ Status</span><br/><span class="property-search-values">{{property.StatusLabel}}</span></div>
      <div class="p-col-2">
          <span class="property-search-label">Loan Status</span><br>
          <span class="property-search-values hoverLink" (mouseover)="op2.show($event)" (mouseout)="op2.hide($event)">{{property.SVLoanStatus}}</span>
      </div>
      <div class="p-col-2"><span class="property-search-label">Servicer</span><br/><span class="property-search-values">{{property.CoServicerName}}</span></div>
      <div class="p-col-2"><span class="property-search-label">Servicer #</span><br/><span class="property-search-values">{{property.SVServicerID}}</span></div>
    </div>
    <div class="p-grid">
        <div class="p-col-2"><span class="property-search-label">Occupancy</span><br/><span class="property-search-values">{{property.Occupancy}}</span></div>
        <div class="p-col-2"><span class="property-search-label">LPI Date</span><br/><span class="property-search-values">{{property.LpiDate | dateTimeFormat}}</span></div>
        <div class="p-col-2"><span class="property-search-label">Days DQ</span><br/><span class="property-search-values">{{property.DaysDQ}}</span></div>
        <div class="p-col-2"><span class="property-search-label">Unit Count</span><br/><span class="property-search-values">{{property.UnitCount}}</span></div>
        <div class="p-col-2"><span class="property-search-label">Inspection Count</span><br/><span class="property-search-values">{{property.InspectionCount}}</span></div>
        <div class="p-col-2"><span class="property-search-label">Property Type</span><br/><span class="property-search-values">{{property.PropertyType}}</span></div>
    </div>

    
  </div> 
</div>
<p-overlayPanel #op2 [dismissable]="true" appendTo="body">
  <p-table [value]=[property] autoLayout=true [style]="{'max-width': '700px'}">
    <ng-template pTemplate="header">
        <tr>
            <th>SV BK Ind</th>
            <th>SV Litigation Ind</th>
            <th>SV Loss Mit Ind</th>
            <th>EQ Borr Maint Property</th>
            <th>SV SCRA Military Ind</th>
            <th>SV SCRA Military Pres Ind</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-prop>
        <tr>
            <td>{{prop.SVBankruptcyIndicator}}</td>
            <td>{{prop.SVLitigationIndicator}}</td>
            <td>{{prop.SVLossMitIndicator}}</td>
            <td>{{prop.BorrowerMaintainingProperty}}</td>
            <td>{{prop.SVSCRAMilitaryIndicator}}</td>
            <td>{{prop.SVSCRAMilitaryPreservationIndicator}}</td>
        </tr>
    </ng-template>
  </p-table>
</p-overlayPanel>


